import hostMap from './hostMap';
import {defer} from '@servicenow/ui-internal';

function createThrottle(fn, {limit = 0}, ctx, runEffectFn) {
	let free = true;
	return function throttledEffect(...args) {
		if (!free) return;

		free = false;
		runEffectFn(fn, args, ctx);
		defer(() => {
			free = true;
		}, limit);
	};
}

/**
 * Throttle modifier for effect functions
 *
 * @param host
 * @param actionType
 * @param effectFn
 * @param modifier
 */
export default function throttle(host, actionType, effectFn, modifier, ctx, runEffectFn) {
	if (!hostMap.has(host)) hostMap.set(host, new WeakMap());

	const effectMap = hostMap.get(host);

	if (!effectMap.has(effectFn)) effectMap.set(effectFn, {});

	const actionMappings = effectMap.get(effectFn);
	if (!actionMappings[actionType])
		actionMappings[actionType] = createThrottle(effectFn, modifier, ctx, runEffectFn);

	return actionMappings[actionType];
}
